
export const environment = 'network'

export const sysVersion='V6.19.41-260606'
//局域网配置
//export const environment = 'local'


